import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as $ from 'jquery';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';
import { DataService } from 'src/app/services/data.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss']
})
export class InsuranceComponent implements OnInit {


  showInsuranceBenefits: boolean = false;

  showTC: boolean = false;

  selectedRelation:any = '';

  revisedEmi:any ='';

  thenMonths:any ='';

  payMonths:any ='';

  isChecked: boolean = false;

  selectedCard: any = 0;

  iframeSrc: SafeResourceUrl;

  iframeSrc2: SafeResourceUrl;




  constructor(public util: UtilService,public data:DataService,private sanitizer: DomSanitizer) {   
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.util.isProduction? ConstantData.insuranceBenifit_prod: ConstantData.insuranceBenifit);
    this.iframeSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl( this.util.isProduction? ConstantData.insuranceTermsandConditionUrl_prod: ConstantData.insuranceTermsandConditionUrl);
  }


  formGroup: FormGroup = new FormGroup({
    'name': new FormControl('', [Validators.required]),
    'relationship': new FormControl('', [Validators.required]),
  });



  ngOnInit(): void {
    this.init();
    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.init();
    })
  }

  init(){
    if(!this.util.loanDetails){
      return;
    }
    this.util.handleRequests('get', this.util.getUrl('loan_insurance', [this.util.loanDetails.loanId])).then(res => {
      this.util.setCache("insuranceList",  res.content);
      // this.util.getCache("insuranceList");
      this.data.getDataFromContantAll('insurance_nominee');
    });
  }

  getRelationship(id:any,relation:any){
    this.selectedRelation = relation;
    this.formGroup.controls['relationship'].setValue(relation);
  }


  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  showFaq(id: string, evt: any) {
    $(evt.target).addClass('selected').parent().siblings().children('.faq-head').removeClass('selected');
    $('#' + id).addClass('open').parent().siblings().children('.faq-content').removeClass('open');
  }

  showBenefits() {
    this.showInsuranceBenefits = true;
  }

  selectCard(index: number): void {
    this.selectedCard = index;
  }


  saveInsuranceDetails(isSkiped:boolean){
    let requestData = {
        "calculatorResponse": {
            "emiAmount": this.util.getCache("insuranceList")[this.selectedCard].emiAmount,
            "emiBeforeMoratorium": this.util.getCache("insuranceList")[this.selectedCard].emiBeforeMoratorium,
            "id": this.util.getCache("insuranceList")[this.selectedCard].id,
            "premium": this.util.getCache("insuranceList")[this.selectedCard].premium
        },
        "insuranceApplicable": !isSkiped,
        "nomineeName":isSkiped ? null : this.formGroup.get('name')?.value,
        "nomineeRelation": isSkiped ? null : this.formGroup.get('relationship')?.value,
        "plan": isSkiped ? null : this.util.getCache("insuranceList")[this.selectedCard].id  
    };
    // isSkiped ? ( console.log(CleverTapConstents.accepted_loan_terms),
    // this.util.cleverTapEventCall(CleverTapConstents.moratorium_selected,{
    //   loanId:this.util.loanDetails.loanId,
    //     productCode:this.util.loanDetails.productCategory
    // })): "";
    let skippedObj ={
        'insuranceApplicable': false,
    }
    
    this.util.handleRequests('put', this.util.getUrl('loan_insurance_update', [this.util.loanDetails.loanId]),isSkiped ? skippedObj : requestData).then(res => {
      this.util.getProducts().then(()=>{
        this.util.navigationHandler();
      })
    });
    
  }

  showTc(){
    this.showTC = true;
  }

  back(){
    this.util.route('home');
  }





}
